import { createLogger } from '@/lib/logger';

const logger = createLogger('utils/debug');

/**
 * Centralized Debug Utility
 * Debug logging helpers (disabled by default)
 */

const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';
const noop = (..._args: unknown[]) => {};

// Main debugLog function for backward compatibility (disabled to reduce noise)
export const debugLog = noop;

// Enhanced debug utilities with specific purposes
export const debug = {
  /**
   * General debug logging (disabled)
   */
  log: noop,
  
  /**
   * Warning logging - replaces logger.warn  
   */
  warn: IS_DEVELOPMENT ? logger.warn.bind(console) : noop,
  
  /**
   * Error logging - always enabled (critical for production debugging)
   */
  error: logger.error.bind(console),
  
  /**
   * Store-specific logging
   */
  store: noop,
  
  /**
   * API-specific logging
   */
  api: noop,
  
  /**
   * Component-specific logging
   */
  component: noop,
  
  /**
   * Performance logging
   */
  perf: noop,
  
  /**
   * Group logging for complex operations
   */
  group: {
    start: noop,
    end: noop,
  },
};

/**
 * Legacy compatibility - gradually replace with specific methods above
 */
export const conditionalLog = debugLog;

/**
 * Development-only logging that's completely stripped from production
 */
export const devOnly = {
  log: noop,
  warn: IS_DEVELOPMENT ? logger.warn.bind(console) : noop,
  // Note: errors are always logged even in production for debugging
}; 
